let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hBNuK")).then(() => parcelRequire('6021Z'));